module.exports = __webpack_public_path__ + "static/img/zxfw-NRopHoA8.bcefa83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/zxfw-NRopHoA8.png
// module id = +pJK
// module chunks = 16